import React, { Component } from "react";
import { Grid, Col, Row, Button, Modal, Image } from "react-bootstrap";
import Card from "../../../components/Card/Card";
import Loading from "../../../views/Loading";
import _ from "lodash";

import ReactTable from "react-table-6";
import { sociedades } from "../../../variables/constantes";

import "react-table-6/react-table.css";
import "./style.css";
import Swal from 'sweetalert2'; 
import { dominio } from "../../../routes_backend/routes.jsx";

class AutorizarOTs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      isLoading: false,
      listAutorizaciones: [],
      comments: "",
      status: 1,

      sociedad: sociedades,
      is_sociedad: "SBO_GT_TRANSFLESA",

      showModal: false,
      showModalconfirm: false,
      messageConfirm: "",
      responde_server: "",

      usrWisap: "",
      userWisapId: "",
      db_sociedad: "",
      url_autorizaciones: "",
      name_sociedad: "",
      id_sociedad: "",

      // === Nuevo: manejo de selección múltiple ===
      selectedRows: {},      // { [DocEntry]: true }
      selectAll: false,
      bulkStatus: "",        // ardPending | ardApproved | ardNotApproved
      bulkProcessing: false, // loader mientras corre la acción masiva

      // modal vista previa:
      listAutorizacionesVistaPrevia: [],
      isModalOpenVistaPrevia: false,
    };
    this.onChange = this.onChange.bind(this);
    this.abrirModalVistaPrevia = this.abrirModalVistaPrevia.bind(this);
    this.cerrarModalVistaPrevia = this.cerrarModalVistaPrevia.bind(this);
  }

  onChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }
  handleCloseEnable = () => {
    this.setState({ showModalconfirm: false });
  };

  componentWillMount(user, Iduser, sociedad) {
    let token = localStorage.getItem("token");
    if (token !== null) {
      let token_Data = JSON.parse(token);
      console.log(token_Data);
      token_Data.forEach((element) => {
        user = element.USER_CODE;
        Iduser = element.U_UserId;
        sociedad = element.db;
      });
    }
    this.datosBD();
  }

  datosBD = () => {
    this.get_list_autorizaciones();
  };

  get_list_autorizaciones = (user, sociedad) => {
    const { is_sociedad } = this.state;

    let username = '';
    let password = '';
    let codigoUser = '';
    const token = localStorage.getItem('token');
    const token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
        codigoUser = element.U_UserId;
      });
    }

    if (token_Data === null) {
      this.props.history.push('');
    }

    this.setState({
      message: "",
      isLoading: true,
      listAutorizaciones: [],
      comments: "",
      status: 1,
      showModal: false,
      showModalconfirm: false,
      messageConfirm: "",
      responde_server: "",
      // limpiar selección al refrescar lista:
      selectedRows: {},
      selectAll: false,
      bulkStatus: "",
    });

    fetch(`${dominio}/get_ListRequisicionesOT`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username,
        password,
        codigoUser,
        is_sociedad,
      }),
    })
      .then(async (res) => {
        if (res.status === 404) {
          const errorData = await res.json();
          this.setState({
            isLoading: false,
            message: errorData.error || "No hay autorizaciones pendientes con este usuario",
          });
          return;
        }
        const data = await res.json();
        console.log(data);
        this.setState({
          listAutorizaciones: data,
          isLoading: false,
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          isLoading: false,
          message: 'No hay autorizaciones pendientes con este usuario',
        });
      });
  };

  // === Modificado: aceptar opciones para uso "silencioso" en masivo ===
  autorizar = async (data, { silent = false, skipRefresh = false } = {}) => {
    this.setState({
      message: "",
      isLoading: silent ? this.state.isLoading : true,
      messageConfirm: "",
    });

    let commentario = data.Comments || "";
    let status = data.estatus || "";

    if (status === "") {
      if (!silent) {
        this.setState({
          isLoading: false,
          message: "Estatus no proporcionado.",
        });
      }
      return { ok: false, error: "Estatus no proporcionado." };
    }

    let token = localStorage.getItem("token");
    let token_Data = JSON.parse(token);

    if (!token_Data) {
      this.props.history.push("");
      return { ok: false, error: "Sin sesión" };
    }

    let { WddCode, DocEntry, U_Numero_Doc: requiFracttal } = data;
    let username = "";
    let password = "";

    token_Data.forEach((element) => {
      username = element.usuarioSAP;
      password = element.contraseñaSAP;
    });

    try {
      await fetch(`${dominio}/UpdateDraftComments`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ DocEntry, commentario }),
      });

      const response = await fetch(`${dominio}/updateAutorizaciones`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          WddCode,
          commentario,
          status,
          username,
          password,
        }),
      });

      const respJson = await response.json();

      if (!respJson.success) {
        throw new Error(respJson[0]?.message || respJson.error || "Error desconocido al actualizar autorizaciones");
      }

      if (!silent) {
        Swal.fire({
          icon: "success",
          title: "Éxito",
          text: "Registro actualizado correctamente",
        });
      }

      if (status === "ardApproved") {
        try {
          await fetch(`${dominio}/ConvertDraftToDocument`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ DocEntry }),
          });

          await fetch(`${dominio}/CrearSolicitudesCompra`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ requiFracttal }),
          });
        } catch (error) {
          console.error("Error al procesar solicitudes aprobadas:", error);
          if (!silent) {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Error al procesar solicitudes aprobadas.",
            });
          }
          return { ok: false, error: "Error al procesar aprobaciones." };
        }
      }

      return { ok: true };
    } catch (error) {
      console.error("Error en la solicitud:", error);
      if (!silent) {
        Swal.fire({
          icon: "error",
          title: "Error en la solicitud",
          text: error.message || "Mensaje de error no disponible",
        });
      }
      return { ok: false, error: error.message || "Error desconocido" };
    } finally {
      if (!skipRefresh) {
        this.datosBD();
      }
      if (!silent) {
        this.setState({ isLoading: false });
      }
    }
  };

  // ===== Vista previa (igual que tenías) =====
  ver_solicitud = (solicitud, type, codigoUser) => {
    const { is_sociedad } = this.state;

    console.log(is_sociedad);

    if (is_sociedad === 'SBO_MACIZO') {
      var username = '';
      var password = '';
      let token = localStorage.getItem('token');
      let token_Data = JSON.parse(token);

      if (token_Data !== null) {
        token_Data.forEach((element) => {
          username = element.usuarioSAP;
          password = element.contraseñaSAP;
          codigoUser = element.U_UserId;
        });
      }

      if (token_Data === null) {
        this.props.history.push('');
      }
      console.log(token_Data);

      this.setState({
        message: "",
        isLoading: true,
        comments: "",
        status: 1,
        showModal: false,
        showModalconfirm: false,
        messageConfirm: "",
        responde_server: "",
      });

      const response = fetch(`${dominio}/get_ListRequisicionesVistaPrevia`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          username,
          password,
          solicitud,
        }),
      });

      response
        .then(async (res) => {
          let data = await res.json();
          console.log(data);
          this.setState({
            listAutorizacionesVistaPrevia: data,
            isLoading: false,
          });
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            isLoading: false,
            message: 'No hay autorizaciones pendientes con este usuario'
          });
        });
    }
  };

  abrirModalVistaPrevia(solicitud, type, codigoUser) {
    const { is_sociedad } = this.state;

    console.log(is_sociedad);

    if (is_sociedad === 'SBO_GT_TRANSFLESA') {
      var username = '';
      var password = '';
      let token = localStorage.getItem('token');
      let token_Data = JSON.parse(token);

      if (token_Data !== null) {
        token_Data.forEach((element) => {
          username = element.usuarioSAP;
          password = element.contraseñaSAP;
          codigoUser = element.U_UserId;
        });
      }

      if (token_Data === null) {
        this.props.history.push('');
      }

      this.setState({
        message: "",
        isLoading: true,
      });

      const response = fetch(`${dominio}/get_ListRequisicionesVistaPrevia`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          username,
          password,
          solicitud,
        }),
      });

      response
        .then(async (res) => {
          let data = await res.json();
          console.log(data);
          this.setState({
            listAutorizacionesVistaPrevia: data,
            isLoading: false,
            isModalOpenVistaPrevia: true,
          });
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            isLoading: false,
            message: 'No hay autorizaciones pendientes con este usuario'
          });
        });
    }
  }

  cerrarModalVistaPrevia() {
    this.setState({ isModalOpenVistaPrevia: false });
  }
  cerrarModalAdjuntos() {
    this.setState({ isModalOpenAdjuntos: false });
  }

  getComments = (index, Comments) => {
    let tabledata = [...this.state.listAutorizaciones];
    tabledata[index].Comments = Comments;
  };
  get_status = (index, estatus) => {
    let tabledata = [...this.state.listAutorizaciones];
    tabledata[index].estatus = estatus;
  };

  // ====== NUEVO: helpers de selección múltiple ======
  rowKey = (row) => String(row.DocEntry ?? row.WddCode ?? row.NumAtCard ?? Math.random());

  toggleRow = (row) => {
    const key = this.rowKey(row);
    this.setState((prev) => {
      const selectedRows = { ...prev.selectedRows };
      if (selectedRows[key]) delete selectedRows[key];
      else selectedRows[key] = true;
      const anySelected = Object.keys(selectedRows).length > 0;
      return {
        selectedRows,
        selectAll: anySelected && Object.keys(selectedRows).length === prev.listAutorizaciones.length,
      };
    });
  };

  toggleSelectAll = () => {
    const { selectAll, listAutorizaciones } = this.state;
    if (selectAll) {
      this.setState({ selectedRows: {}, selectAll: false });
    } else {
      const map = {};
      (listAutorizaciones || []).forEach((r) => (map[this.rowKey(r)] = true));
      this.setState({ selectedRows: map, selectAll: true });
    }
  };

  clearSelection = () => {
    this.setState({ selectedRows: {}, selectAll: false, bulkStatus: "" });
  };

  handleBulkStatusChange = (e) => {
    this.setState({ bulkStatus: e.target.value });
  };

  autorizarSeleccionados = async () => {
    const { selectedRows, listAutorizaciones, bulkStatus } = this.state;
    if (!bulkStatus) {
      Swal.fire({ icon: "warning", title: "Selecciona un estado", text: "Debes escoger Pendiente / Autorizado / Rechazado." });
      return;
    }
    const selectedList = (listAutorizaciones || []).filter((r) => selectedRows[this.rowKey(r)]);
    if (selectedList.length === 0) {
      Swal.fire({ icon: "info", title: "Sin selección", text: "No hay filas seleccionadas." });
      return;
    }

    this.setState({ bulkProcessing: true, message: "" });

    let ok = 0, fail = 0;
    for (const item of selectedList) {
      const payload = { ...item, estatus: bulkStatus }; // respeta comentarios por fila si ya fueron escritos
      const res = await this.autorizar(payload, { silent: true, skipRefresh: true });
      if (res?.ok) ok += 1;
      else fail += 1;
    }

    // refrescar una sola vez al final
    await this.datosBD();

    this.setState({ bulkProcessing: false, selectedRows: {}, selectAll: false, bulkStatus: "" });

    Swal.fire({
      icon: fail > 0 ? "warning" : "success",
      title: "Autorización masiva",
      html: `Procesados: <b>${selectedList.length}</b><br/>Éxitos: <b style="color:green">${ok}</b><br/>Fallidos: <b style="color:#b00">${fail}</b>`,
    });
  };

  render() {
    const {
      listAutorizacionesVistaPrevia,
      isLoading,
      message,
      isModalOpenVistaPrevia,
      listAutorizaciones,
      selectedRows,
      selectAll,
      bulkStatus,
      bulkProcessing,
    } = this.state;

    const total = Array.isArray(listAutorizacionesVistaPrevia)
      ? listAutorizacionesVistaPrevia.reduce((acc, item) => acc + parseFloat(item.LineTotal), 0).toFixed(2)
      : '0.00';

    const formatDate = (dateString) => {
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('es-ES', options).format(date);
    };

    let data_status = [
      { id: 'Pendiente', text: "ardPending" },
      { id: 'Autorizado', text: "ardApproved" },
      { id: 'Rechazado', text: "ardNotApproved" },
    ];

    // ==== NUEVO: columna checkbox ====
    let columns = [
      {
        Header: (
          <input
            type="checkbox"
            checked={selectAll}
            onChange={this.toggleSelectAll}
            title="Seleccionar todo"
          />
        ),
        accessor: "select",
        width: 45,
        sortable: false,
        filterable: false,
        Cell: (props) => {
          const original = props.row._original || props.original || props.row;
          const key = this.rowKey(original);
          const checked = !!selectedRows[key];
          return (
            <input
              type="checkbox"
              checked={checked}
              onChange={() => this.toggleRow(original)}
              title="Seleccionar fila"
            />
          );
        },
      },
      {
        Header: "solicitud",
        accessor: "DocEntry",
        Cell: (props) => (
          <Button
            bsStyle="info"
            bsSize="small"
            active
            onClick={() =>
              this.abrirModalVistaPrevia(props.row.DocEntry, props.original.DocType)
            }
          >
            {props.row.DocEntry}
          </Button>
        ),
      },
      {
        Header: "Documento",
        accessor: "WddCode",
        getProps: () => ({ style: { fontSize: "12px" } }),
      },
      {
        Header: "Ots Fracttal",
        accessor: "NumAtCard",
        getProps: () => ({ style: { fontSize: "12px" } }),
      },
      {
        Header: "Requisicion Fracttal",
        accessor: "U_Numero_Doc",
        getProps: () => ({ style: { fontSize: "12px" } }),
      },
      {
        Header: "ID Usuario",
        accessor: "OwnerID",
        getProps: () => ({ style: { fontSize: "12px" } }),
      },
      {
        Header: "Solicitante",
        accessor: "U_NAME",
        getProps: () => ({ style: { fontSize: "12px" } }),
      },
      {
        Header: "Fecha",
        accessor: "DocDate",
        Cell: (props) => <div>{props.row.DocDate.slice(0, -14)}</div>,
        getProps: () => ({ style: { fontSize: "12px" } }),
      },
      {
        Header: "Hora",
        accessor: "CreateTime",
        getProps: () => ({ style: { fontSize: "12px" } }),
      },
      {
        Header: "Estado",
        accessor: "estatus",
        width: 150,
        Cell: (props) => (
          <select
            value={
              props.row._original.estatus !== undefined
                ? 1
                : props.row._original.estatus
            }
            name="id_status"
            id="id_status"
            className="form-control"
            onChange={(e) => this.get_status(props.index, e.target.value)}
          >
            {data_status &&
              data_status.map((res) => (
                <option key={res.id} value={res.text}>
                  {res.id}
                </option>
              ))}
          </select>
        ),
      },
      {
        Header: "Comentarios",
        accessor: "Comments",
        width: 250,
        Cell: (props) => (
          <textarea
            className="comments"
            maxLength="75"
            onChange={(e) => this.getComments(props.index, e.target.value)}
            type="text"
          />
        ),
      },
      {
        Header: "Autorizar",
        accessor: "CreateTime",
        Cell: (props) => (
          <Button
            bsStyle="primary"
            bsSize="small"
            active
            onClick={() => this.autorizar(props.row._original)}
          >
            Autorizar
          </Button>
        ),
      },
    ];

    // Resumen de selección
    const selectedCount = Object.keys(selectedRows).length;

    return (
      <div className="content" style={{ textAlign: "center", alignItems: "center" }}>
        <Grid fluid>
          <Row>
            <Col md={12}>
              {/* Modal Vista Previa */}
              <div className="modal" tabIndex="-1" role="dialog" style={{ display: isModalOpenVistaPrevia ? 'block' : 'none' }}>
                <div className=" modal-dialog-custom-width" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Vista Previa</h5>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.cerrarModalVistaPrevia}>
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                      {Array.isArray(listAutorizacionesVistaPrevia) && listAutorizacionesVistaPrevia.length > 0 && (
                        <>
                          <div>
                            <strong>Solicitante:</strong> {listAutorizacionesVistaPrevia[0].U_NAME} &nbsp;&nbsp;&nbsp;
                            <strong># Documento:</strong> {listAutorizacionesVistaPrevia[0].DraftEntry}
                          </div>

                          <table>
                            <thead>
                              <tr>
                                <th>Codigo</th>
                                <th>Descripcion</th>
                                <th>Precio con IVA</th>
                                <th>Almacen</th>
                                <th>Cantidad</th>
                                <th>Stock</th>
                                <th>Comprometido</th>
                                <th>Precio</th>
                                <th>Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {listAutorizacionesVistaPrevia.map((item, index) => (
                                <tr key={index}>
                                  <td>{item.ItemCode}</td>
                                  <td>{item.Dscription}</td>
                                  <td>{parseFloat(item.PriceAfVAT).toFixed(2)}</td>
                                  <td>{item.WhsCode}</td>
                                  <td>{item.Quantity}</td>
                                  <td>{item.IsCommited}</td>
                                  <td>{item.OnHand}</td>
                                  <td>{parseFloat(item.Price).toFixed(2)}</td>
                                  <td>{parseFloat(item.LineTotal).toFixed(2)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>

                          <div className="info-section">
                            <div className="comments">
                              <strong>Comentario:</strong>
                              &nbsp;
                              {listAutorizacionesVistaPrevia[0].Comments}
                            </div>
                            <div className="total">
                              <strong>Total:</strong> {total}
                              <br />
                              <strong>Total/IVA:</strong> {parseFloat(listAutorizacionesVistaPrevia[0].DocTotal).toFixed(2)}
                            </div>
                          </div>

                          <div className="create-date">
                            <strong>Fecha Creacion:</strong> {formatDate(listAutorizacionesVistaPrevia[0].CreateDate)}
                          </div>
                        </>
                      )}
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={this.cerrarModalVistaPrevia}>
                        Cerrar
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <Card
                title="AUTORIZACIONES"
                category="AUTORIZACIONES"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="content">
                    {/* === NUEVO: Barra de acción masiva === */}
                    {selectedCount > 0 && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          background: "#f5f8ff",
                          border: "1px solid #e2e6f0",
                          padding: "8px 12px",
                          borderRadius: 6,
                          marginBottom: 12,
                          justifyContent: "space-between"
                        }}
                      >
                        <div style={{ textAlign: "left" }}>
                          <strong>{selectedCount}</strong> seleccionado(s)
                        </div>

                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <select
                            value={bulkStatus}
                            onChange={this.handleBulkStatusChange}
                            className="form-control"
                            style={{ minWidth: 200 }}
                            disabled={bulkProcessing}
                            title="Estado para aplicar a todos los seleccionados"
                          >
                            <option value="">-- Selecciona un estado --</option>
                            {data_status.map(s => (
                              <option key={s.id} value={s.text}>{s.id}</option>
                            ))}
                          </select>

                          <Button
                            bsStyle="primary"
                            bsSize="small"
                            active
                            disabled={!bulkStatus || bulkProcessing}
                            onClick={this.autorizarSeleccionados}
                            title="Autorizar todos los seleccionados"
                          >
                            {bulkProcessing ? "Procesando..." : "Autorizar seleccionados"}
                          </Button>

                          <Button
                            bsStyle="default"
                            bsSize="small"
                            onClick={this.clearSelection}
                            disabled={bulkProcessing}
                            title="Limpiar selección"
                          >
                            Limpiar
                          </Button>
                        </div>
                      </div>
                    )}

                    <div className="row">
                      <div className="col-sm-12">
                        <br />
                      </div>

                      <p style={style.errorMessage}>{message}</p>
                      <br />
                      &nbsp;
                      <br />

                      {!_.isEmpty(listAutorizaciones) ? (
                        <div className="col-sm-12">
                          <br />
                          <br />
                          <ReactTable
                            data={listAutorizaciones}
                            columns={columns}
                            defaultPageSize={listAutorizaciones.length}
                            filterable={true}
                            defaultFilterMethod={(filter, row, column) => {
                              const id = filter.pivotId || filter.id;
                              if (typeof filter.value === "object") {
                                return row[id] !== undefined
                                  ? filter.value.indexOf(row[id]) > -1
                                  : true;
                              } else {
                                return row[id] !== undefined
                                  ? String(row[id]).indexOf(filter.value) > -1
                                  : true;
                              }
                            }}
                          />
                        </div>
                      ) : (
                        <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                          <br /><br /><br />
                        </p>
                      )}
                    </div>

                    {this.state.isLoading === false
                      ? this.state.showModal && (
                        <Modal
                          show={this.state.showModalconfirm}
                          onHide={this.handleCloseEnable}
                          bsSize="sm"
                        >
                          <Modal.Header closeButton />
                          <Modal.Body>
                            <div>
                              <center>
                                <strong>
                                  {this.state.responde_server === true
                                    ? "Datos Actualizados Exitosamente"
                                    : "¡Ha ocurido un error!"}
                                </strong>
                              </center>
                              <br />
                              <center>
                                <p style={style.message}>{message}</p>
                                <div>{this.state.messageConfirm}</div>
                              </center>
                              <br />
                              <center>
                                {this.state.responde_server === true ? (
                                  <Image
                                    src={
                                      "https://us.123rf.com/450wm/photoart23d/photoart23d1902/photoart23d190201464/117662421-marcas-de-verificaci%C3%B3n-degradado-verde-icono-de-marca-dentro-del-c%C3%ADrculo-ilustraci%C3%B3n-vectorial.jpg?ver=6"
                                    }
                                    width={"25%"}
                                    height={"auto"}
                                  />
                                ) : (
                                  <Image
                                    src={
                                      "https://us.123rf.com/450wm/arcady31/arcady311108/arcady31110800003/10101127-vector-attention-warning-sign.jpg?ver=6"
                                    }
                                    width={"30%"}
                                    height={"auto"}
                                  />
                                )}
                              </center>
                            </div>
                          </Modal.Body>
                          <Modal.Footer>
                            <div style={{ float: "left" }}>
                              <Button
                                onClick={this.handleCloseEnable}
                                bsStyle="info"
                                active
                              >
                                Cerrar!
                              </Button>
                            </div>
                          </Modal.Footer>
                        </Modal>
                      )
                      : null}
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
        {(isLoading || bulkProcessing) && <Loading />}
      </div>
    );
  }
}

export default AutorizarOTs;

const style = {
  message: {
    fontWeight: "bold",
    fontSize: "12px",
    height: "10px",
    color: "red",
  },
  errorMessage: {
    fontWeight: "bold",
    fontSize: "12px",
    color: "red",
  },
};
